import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import React from 'react';
import withTheme from '@material-ui/core/styles/withTheme';
import Form from '../../form';
import DropdownButtonContext from './Context';

var useSelectStyles = function useSelectStyles(theme) {
  return {
    valueContainer: function valueContainer(base) {
      return _objectSpread({}, base, {
        minHeight: '38px',
        paddingLeft: theme.spacing(2),
        cursor: 'pointer'
      });
    }
  };
};
/** @param {import('./types').DropdownButtonDataSelectProps} props */


var DropdownButtonDataSelect = function DropdownButtonDataSelect(props) {
  var defaultValue = props.defaultValue,
      dataType = props.dataType,
      dataProps = props.dataProps,
      theme = props.theme;

  var _React$useContext = React.useContext(DropdownButtonContext),
      onClick = _React$useContext.onClick;

  var customSelectStyles = useSelectStyles(theme);
  return React.createElement(Form.Input.DataSelect, {
    id: dataType,
    dataType: dataType,
    dataProps: dataProps,
    onChange: function onChange(value) {
      onClick(null, {
        label: value,
        value: _defineProperty({}, dataType, value)
      });
    },
    variant: "standard",
    defaultValue: defaultValue ? defaultValue : null,
    textFieldProps: {
      InputProps: {
        disableUnderline: true
      }
    },
    customSelectStyles: customSelectStyles
  });
};

export default withTheme(DropdownButtonDataSelect);